import { render, staticRenderFns } from "./MyCenter.vue?vue&type=template&id=9f930c30&scoped=true&"
import script from "./MyCenter.vue?vue&type=script&lang=js&"
export * from "./MyCenter.vue?vue&type=script&lang=js&"
import style0 from "./MyCenter.vue?vue&type=style&index=0&id=9f930c30&prod&lang=scss&scoped=true&"
import style1 from "./MyCenter.vue?vue&type=style&index=1&id=9f930c30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f930c30",
  null
  
)

export default component.exports